// import { useEffect, useState } from "react"
// import { useDispatch, useSelector } from "react-redux"
// import { Getalldatasearch, Getallleadsdublicatedinadmindashboard } from "../Redux/Actions/UsersAction"
// import { useLocation } from "react-router-dom"
// import { io } from "socket.io-client"
// import { db_url } from "../Api/BaseUrl"

// export const AllLeadHook = () => {
//   const dispatch = useDispatch()
//   const location = useLocation()

//   const [userlogin, setuserlogin] = useState('')
//   const [loading, setloading] = useState(true)
//   const [socket, setSocket] = useState(null)

//   // 🟡 users from redux
//   const users = useSelector(state => state.Allusers.Get_users)
//   const pagecount = users?.pagination?.NumberOfPages ?? 1;

//   // 🟢 local state for dynamic updates without re-fetch
//   const [usersarray, setUsersArray] = useState([])

//   // ⬅️ تحميل المستخدم من localStorage
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user")
//     if (storedUser) {
//       setuserlogin(JSON.parse(storedUser))
//     }
//   }, [])

//   // ⬅️ تحميل البيانات من الريدوكس وحفظها في local state
//   // useEffect(() => {
//   //   const fetchData = async () => {
//   //     setloading(true)
//   //     const searchParams = new URLSearchParams(location.search)
//   //     const stage = searchParams.get("stage")
//   //    const duplicates = searchParams.get("duplicates");

//   //   if (duplicates === 'true') {
//   //     // استخدم إكشن الـ duplicates إذا وجدت في الـ URL
//   //     await dispatch(Getallleadsdublicatedinadmindashboard());
//   //   } else {
//   //     // استخدم الإكشن العادي مع فلتر الـ stage إذا وجد
//   //     let query = "leadisactive=true";
//   //     if (stage) query += `&stage=${encodeURIComponent(stage)}`;
//   //     await dispatch(Getalldatasearch(query));
//   //   }
//   //     setloading(false)
//   //   }

//   //   fetchData()
//   // }, [dispatch, location.search])

//    const fetchData = async () => {
//     setloading(true)
//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")
//         const limit = searchParams.get("limit") || 100000 // ⬅️ زود الـ limit

//     if (duplicates === 'true') {
//       await dispatch(Getallleadsdublicatedinadmindashboard())
//     } else {
//       let query = `leadisactive=true&limit=${limit}`
//       if (stage) query += `&stage=${encodeURIComponent(stage)}`
//       await dispatch(Getalldatasearch(query))
//     }
//     setloading(false)
//   }

//   useEffect(() => {
//     fetchData()
//   }, [dispatch, location.search])

//   // 🟢 عند تحديث users من redux → حدث usersarray
//   useEffect(() => {
//     if (Array.isArray(users?.data)) {
//       setUsersArray(users.data)
//     }
//   }, [users])

//   // ⬅️ استماع لـ socket وإضافة الـ lead الجديد يدويًا
//   useEffect(() => {
//     // const newSocket = io("https://apirender8.onrender.com")
//         const newSocket = io(db_url)

//     setSocket(newSocket)

//     newSocket.on("connect", () => {
//       console.log("📡 Socket connected")
//     })

//     newSocket.on("newLead", (newLeadData) => {
//       // console.log("🆕 New lead received via socket:", newLeadData)

//       setUsersArray(prev => {
//         const isExist = prev.some(item => item._id === newLeadData._id)
//         if (isExist) return prev // ✅ لو موجود ما تضيفوش تاني
//         return [newLeadData, ...prev] // ➕ أضفه أول الـ array
//       })
//     })

//     // 🔄 تعديل lead (زي تغيير stage أو sales)
// newSocket.on("newNotification", (updatedLead) => {
//   // console.log("🔄 Lead updated via socket:", updatedLead)

//   setUsersArray(prev =>
//     prev.map(item => item._id === updatedLead._id ? updatedLead : item)
//   )
// })

//     return () => {
//       newSocket.disconnect()
//     }
//   }, [])

//   // 🔁 getpages placeholder
//   const getpages = async (page) => {
//     // dispatch(GetalldataLeadsWithPages(page, limit))
//   }

//   // 🟢 تجهيز allleads من usersarray
//   const allleads = usersarray.map(item => ({
//     _id: item._id,
//     name: item.name,
//     email: item.email,
//     phone: item.phone,
//     project: item.project?.name || "",
//     sales: item?.sales?.name || null,
//     notes: item.notes,
//     Date: item.date,
//     assign: item.assign,
//     stage: item.stage?.name || "",
//     chanel: item.chanel?.name || "",
//     communicationway: item.communicationway?.name || null,
//     leedtype: item.leedtype,
//     budget: item.budget,
//     stagedateupdated: item.stagedateupdated,
//     createdAt: item.createdAt,
//     updatedAt: item.updatedAt,
//     developer: item.project?.developer || null
//   }))

//   return [usersarray, allleads, loading, pagecount, getpages,fetchData]
// }

// ========================================================================================

// import { useEffect, useState, useRef } from "react"
// import { useDispatch, useSelector } from "react-redux"
// import { Getalldatasearch, Getallleadsdublicatedinadmindashboard } from "../Redux/Actions/UsersAction"
// import { useLocation } from "react-router-dom"
// import { io } from "socket.io-client"
// import { db_url } from "../Api/BaseUrl"

// export const AllLeadHook = () => {
//   const dispatch = useDispatch()
//   const location = useLocation()

//   // 🟡 users from redux
//   const users = useSelector(state => state.Allusers.Get_users)

//   const [userlogin, setuserlogin] = useState('')
//   const [loading, setloading] = useState(true)
//   const [socket, setSocket] = useState(null)

//   // 🟢 local state only
//   const [usersarray, setUsersArray] = useState([])

//   // استخدام useRef للمتابعة
//   const isFetchingRef = useRef(false)
//   const initialLoadDoneRef = useRef(false)
//   const pagecount = 1;

//   // ⬅️ تحميل المستخدم من localStorage
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user")
//     if (storedUser) {
//       setuserlogin(JSON.parse(storedUser))
//     }
//   }, [])

//   // ⬅️ التحميل الأولي السريع - 200 فقط
//   const fetchInitialData = async () => {
//     setloading(true)
//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")

//     console.log("🚀 بدء التحميل الأولي السريع - 200 lead")

//     try {
//       if (duplicates === 'true') {
//         await dispatch(Getallleadsdublicatedinadmindashboard(50))
//       } else {
//         let query = `leadisactive=true&limit=50`
//         if (stage) query += `&stage=${encodeURIComponent(stage)}`
//         await dispatch(Getalldatasearch(query))
//       }
//     } catch (error) {
//       console.error("❌ خطأ في التحميل الأولي:", error)
//     } finally {
//       setloading(false)
//     }
//   }

//   // ⬅️ جلب جميع البيانات المتبقية مرة واحدة - 2000
//   const fetchAllRemainingData = async () => {
//     if (isFetchingRef.current) return

//     isFetchingRef.current = true
//     console.log("🔄 بدء جلب جميع البيانات المتبقية - 2000 lead")

//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")

//     try {
//       let result
//       if (duplicates === 'true') {
//         // جلب 2000 مرة واحدة
//         result = await dispatch(Getallleadsdublicatedinadmindashboard(2000, 1))
//       } else {
//         // جلب 2000 مرة واحدة
//         let query = `leadisactive=true&limit=2000&page=1`
//         if (stage) query += `&stage=${encodeURIComponent(stage)}`
//         result = await dispatch(Getalldatasearch(query))
//       }

//       const allData = result?.payload?.data || result?.data

//       if (Array.isArray(allData) && allData.length > 0) {
//         // 🔥 دمج جميع البيانات مع منع التكرار
//         setUsersArray(prev => {
//           const uniqueNewData = allData.filter(newItem =>
//             !prev.some(oldItem => oldItem._id === newItem._id)
//           )
//           const mergedData = [...prev, ...uniqueNewData]
//           console.log(`✅ تم إضافة ${uniqueNewData.length} lead جديد - الإجمالي: ${mergedData.length}`)
//           return mergedData
//         })

//         // console.log(`🎉 اكتمل تحميل جميع البيانات! الإجمالي: ${usersarray.length + uniqueNewData.length} lead`)
//       }

//     } catch (error) {
//       console.error("❌ خطأ في جلب البيانات المتبقية:", error)

//       // إذا فشل الطلب الكبير، نحاول بطريقة الصفحات
//       console.log("🔄 محاولة بديلة: التحميل عبر الصفحات...")
//       fetchRemainingDataWithPages()
//     } finally {
//       isFetchingRef.current = false
//     }
//   }

//   // ⬅️ بديل إذا فشل الطلب الكبير - التحميل عبر الصفحات
//   const fetchRemainingDataWithPages = async () => {
//     if (isFetchingRef.current) return

//     isFetchingRef.current = true
//     console.log("🔄 بدء التحميل البديل عبر الصفحات...")

//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")

//     try {
//       let currentPage = 2 // نبدأ من الصفحة الثانية
//       let allCollectedData = [...usersarray]

//       while (currentPage <= 10) { // حد أقصى 10 صفحات
//         console.log(`📥 جلب الصفحة ${currentPage}...`)

//         let result
//         if (duplicates === 'true') {
//           result = await dispatch(Getallleadsdublicatedinadmindashboard(500, currentPage))
//         } else {
//           let query = `leadisactive=true&limit=500&page=${currentPage}`
//           if (stage) query += `&stage=${encodeURIComponent(stage)}`
//           result = await dispatch(Getalldatasearch(query))
//         }

//         const newData = result?.payload?.data || result?.data

//         if (Array.isArray(newData) && newData.length > 0) {
//           // إضافة البيانات الجديدة بدون تكرار
//           const uniqueNewData = newData.filter(newItem =>
//             !allCollectedData.some(existingItem => existingItem._id === newItem._id)
//           )

//           allCollectedData = [...allCollectedData, ...uniqueNewData]

//           // تحديث الـ state فوراً
//           setUsersArray(allCollectedData)

//           console.log(`✅ الصفحة ${currentPage}: ${uniqueNewData.length} جديد - ${allCollectedData.length} إجمالي`)

//           // إذا البيانات أقل من 500، يبقى خلصنا
//           if (newData.length < 500) {
//             console.log(`🎉 اكتمل التحميل!`)
//             break
//           }

//           currentPage++
//         } else {
//           console.log(`⏹️ لا توجد بيانات في الصفحة ${currentPage}`)
//           break
//         }

//         await new Promise(resolve => setTimeout(resolve, 300))
//       }

//       console.log(`🎊 اكتمل جلب جميع البيانات! الإجمالي: ${allCollectedData.length} lead`)

//     } catch (error) {
//       console.error("❌ خطأ في التحميل البديل:", error)
//     } finally {
//       isFetchingRef.current = false
//     }
//   }

//   // ⬅️ Effect رئيسي للتحميل
//   useEffect(() => {
//     const initializeData = async () => {
//       if (!initialLoadDoneRef.current) {
//         // 1. التحميل الأولي السريع (200)
//         await fetchInitialData()
//         initialLoadDoneRef.current = true

//         // 2. بدء جلب كل البيانات المتبقية (2000) بعد ثانية واحدة
//         setTimeout(() => {
//           fetchAllRemainingData()
//         }, 1000)
//       }
//     }

//     initializeData()
//   }, [dispatch, location.search])

//   // 🟢 عند تحديث users من redux → حدث usersarray
//   useEffect(() => {
//     console.log("📊 تحديث البيانات من Redux:", users?.data?.length || 0)

//     if (Array.isArray(users?.data)) {
//       setUsersArray(prev => {
//         // 🔥 دمج البيانات مع منع التكرار
//         const newData = users.data.filter(newItem =>
//           !prev.some(oldItem => oldItem._id === newItem._id)
//         )
//         if (newData.length > 0) {
//           const mergedData = [...prev, ...newData]
//           console.log(`🔄 دمج البيانات: ${newData.length} جديد - ${mergedData.length} إجمالي`)
//           return mergedData
//         }
//         return prev
//       })
//     }
//   }, [users])

//   // ⬅️ استماع لـ socket
//   useEffect(() => {
//     const newSocket = io(db_url)
//     setSocket(newSocket)

//     newSocket.on("connect", () => {
//       console.log("📡 Socket connected")
//     })

//     newSocket.on("newLead", (newLeadData) => {
//       console.log("🆕 New lead received via socket")
//       setUsersArray(prev => {
//         const isExist = prev.some(item => item._id === newLeadData._id)
//         if (isExist) return prev
//         return [newLeadData, ...prev]
//       })
//     })

//     newSocket.on("newNotification", (updatedLead) => {
//       console.log("🔄 Lead updated via socket")
//       setUsersArray(prev =>
//         prev.map(item => item._id === updatedLead._id ? updatedLead : item)
//       )
//     })

//     return () => {
//       newSocket.disconnect()
//     }
//   }, [])

//   // 🔁 دالة التحديث اليدوي
//   const fetchData = async () => {
//     console.log("🔄 تحديث يدوي للبيانات")
//     setloading(true)

//     // إعادة تعيين
//     setUsersArray([])
//     initialLoadDoneRef.current = false
//     isFetchingRef.current = false

//     // 1. التحميل الأولي السريع
//     await fetchInitialData()

//     // 2. بدء جلب كل البيانات المتبقية
//     setTimeout(() => {
//       fetchAllRemainingData()
//     }, 1000)
//   }

//   // 🔁 دالة لاستكمال التحميل إذا وقف
//   const resumeLoading = () => {
//     if (!isFetchingRef.current) {
//       console.log("▶️ استكمال التحميل...")
//       fetchAllRemainingData()
//     }
//   }

//   // 🔁 getpages placeholder
//   const getpages = async (page) => {
//     // مش هنستخدم الـ pagination العادي
//   }

//   // 🟢 تجهيز allleads من usersarray
//   const allleads = usersarray.map(item => ({
//     _id: item._id,
//     name: item.name,
//     email: item.email,
//     phone: item.phone,
//     project: item.project?.name || "",
//     sales: item?.sales?.name || null,
//     notes: item.notes,
//     Date: item.date,
//     assign: item.assign,
//     stage: item.stage?.name || "",
//     chanel: item.chanel?.name || "",
//     communicationway: item.communicationway?.name || null,
//     leedtype: item.leedtype,
//     budget: item.budget,
//     stagedateupdated: item.stagedateupdated,
//     createdAt: item.createdAt,
//     updatedAt: item.updatedAt,
//     developer: item.project?.developer || null
//   }))

//   console.log("📋 الحالة النهائية:", {
//     loading,
//     usersarrayLength: usersarray.length,
//     allleadsLength: allleads.length,
//     isFetching: isFetchingRef.current
//   })

//   return [usersarray, allleads, loading, pagecount, getpages, fetchData, resumeLoading]
// }

// import { useEffect, useState, useRef } from "react"
// import { useDispatch, useSelector } from "react-redux"
// import { Getalldatasearch, Getallleadsdublicatedinadmindashboard } from "../Redux/Actions/UsersAction"
// import { useLocation } from "react-router-dom"
// import { io } from "socket.io-client"
// import { db_url } from "../Api/BaseUrl"

// export const AllLeadHook = () => {
//   const dispatch = useDispatch()
//   const location = useLocation()

//   // 🟡 users from redux
//   const users = useSelector(state => state.Allusers.Get_users)

//   const [userlogin, setuserlogin] = useState('')
//   const [loading, setloading] = useState(true)
//   const [socket, setSocket] = useState(null)

//   // 🟢 local state only
//   const [usersarray, setUsersArray] = useState([])

//   // استخدام useRef للمتابعة
//   const isFetchingRef = useRef(false)
//   const currentStageRef = useRef('')
//   const pendingRequestRef = useRef(null)
//   const pagecount = 1;

//   // ⬅️ تحميل المستخدم من localStorage
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user")
//     if (storedUser) {
//       setuserlogin(JSON.parse(storedUser))
//     }
//   }, [])

//   // ⬅️ دالة التحميل الأساسية مع debounce
//   const fetchInitialData = async (stage, duplicates) => {
//     if (isFetchingRef.current) {
//       console.log("⏳ طلب معلق - يوجد طلب قيد التنفيذ")
//       return
//     }

//     isFetchingRef.current = true
//     setloading(true)

//     // 🔥 نعمل reset للبيانات قبل ما نبدأ
//     setUsersArray([])
//     currentStageRef.current = stage || duplicates || 'all'

//     console.log("🚀 بدء تحميل جديد - Stage:", currentStageRef.current)

//     try {
//       if (duplicates === 'true') {
//         await dispatch(Getallleadsdublicatedinadmindashboard(50))
//       } else {
//         let query = `leadisactive=true&limit=50`
//         if (stage) query += `&stage=${encodeURIComponent(stage)}`
//         await dispatch(Getalldatasearch(query))
//       }
//     } catch (error) {
//       console.error("❌ خطأ في التحميل الأولي:", error)
//     } finally {
//       setloading(false)
//       isFetchingRef.current = false

//       // تنظيف أي طلب معلق
//       pendingRequestRef.current = null
//     }
//   }

//   // ⬅️ جلب البيانات المتبقية
//   const fetchAllRemainingData = async () => {
//     if (isFetchingRef.current) return

//     isFetchingRef.current = true

//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")

//     try {
//       let result
//       if (duplicates === 'true') {
//         result = await dispatch(Getallleadsdublicatedinadmindashboard(2000, 1))
//       } else {
//         let query = `leadisactive=true&limit=2000&page=1`
//         if (stage) query += `&stage=${encodeURIComponent(stage)}`
//         result = await dispatch(Getalldatasearch(query))
//       }

//       const allData = result?.payload?.data || result?.data

//       if (Array.isArray(allData) && allData.length > 0) {
//         setUsersArray(prev => {
//           // 🔥 نتأكد إننا بنضيف لبيانات الـ stage الصحيحة فقط
//           const currentStage = stage || duplicates || 'all'
//           if (currentStageRef.current !== currentStage) {
//             console.log("⚠️ تخطي دمج البيانات - الـ stage تغير")
//             return prev
//           }

//           const uniqueNewData = allData.filter(newItem =>
//             !prev.some(oldItem => oldItem._id === newItem._id)
//           )
//           const mergedData = [...prev, ...uniqueNewData]
//           console.log(`✅ تم إضافة ${uniqueNewData.length} lead - الإجمالي: ${mergedData.length}`)
//           return mergedData
//         })
//       }

//     } catch (error) {
//       console.error("❌ خطأ في جلب البيانات المتبقية:", error)
//     } finally {
//       isFetchingRef.current = false
//     }
//   }

//   // ⬅️ Effect رئيسي - مدبوث علشان منع الطلبات المتكررة
//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")
//     const newStage = stage || duplicates || 'all'

//     console.log("🎯 تحقق من تغيير الـ Stage:", {
//       oldStage: currentStageRef.current,
//       newStage: newStage
//     })

//     // إذا الـ stage اختلف، نلغي أي طلب معلق ونبدأ جديد
//     if (currentStageRef.current !== newStage) {
//       console.log("🔄 تغيير في الـ stage - إلغاء الطلبات المعلقة")

//       // إلغاء أي طلب معلق
//       if (pendingRequestRef.current) {
//         clearTimeout(pendingRequestRef.current)
//         pendingRequestRef.current = null
//       }

//       // تأخير بسيط علشان نتأكد إن الـ URL استقر
//       pendingRequestRef.current = setTimeout(() => {
//         fetchInitialData(stage, duplicates)

//         // التحميل الخلفي بعد نجاح التحميل الأولي
//         setTimeout(() => {
//           if (currentStageRef.current === newStage) {
//             fetchAllRemainingData()
//           }
//         }, 1500)
//       }, 300)
//     }

//     return () => {
//       if (pendingRequestRef.current) {
//         clearTimeout(pendingRequestRef.current)
//       }
//     }
//   }, [location.search])

//   // ⬅️ Effect لتحديث البيانات من Redux
//   useEffect(() => {
//     console.log("📊 تحديث من Redux:", users?.data?.length || 0)

//     if (Array.isArray(users?.data)) {
//       setUsersArray(prev => {
//         const searchParams = new URLSearchParams(location.search)
//         const stage = searchParams.get("stage")
//         const duplicates = searchParams.get("duplicates")
//         const currentStage = stage || duplicates || 'all'

//         // 🔥 نتأكد إننا بنضيف لبيانات الـ stage الصحيحة فقط
//         if (currentStageRef.current !== currentStage) {
//           console.log("⚠️ تخطي تحديث Redux - الـ stage تغير")
//           return prev
//         }

//         const newData = users.data.filter(newItem =>
//           !prev.some(oldItem => oldItem._id === newItem._id)
//         )

//         if (newData.length > 0) {
//           console.log(`🔄 إضافة ${newData.length} عنصر من Redux`)
//           return [...prev, ...newData]
//         }

//         return prev
//       })
//     }
//   }, [users])

//   // ⬅️ استماع لـ socket
//   useEffect(() => {
//     const newSocket = io(db_url)
//     setSocket(newSocket)

//     newSocket.on("connect", () => {
//       console.log("📡 Socket connected")
//     })

//     newSocket.on("newLead", (newLeadData) => {
//       console.log("🆕 New lead via socket")
//       setUsersArray(prev => {
//         const isExist = prev.some(item => item._id === newLeadData._id)
//         if (isExist) return prev
//         return [newLeadData, ...prev]
//       })
//     })

//     newSocket.on("newNotification", (updatedLead) => {
//       console.log("🔄 Lead updated via socket")
//       setUsersArray(prev =>
//         prev.map(item => item._id === updatedLead._id ? updatedLead : item)
//       )
//     })

//     return () => {
//       newSocket.disconnect()
//     }
//   }, [])

//   // 🔁 دالة التحديث اليدوي
//   const fetchData = async () => {
//     console.log("🔄 تحديث يدوي")

//     const searchParams = new URLSearchParams(location.search)
//     const stage = searchParams.get("stage")
//     const duplicates = searchParams.get("duplicates")

//     // reset كامل
//     setUsersArray([])
//     isFetchingRef.current = false
//     currentStageRef.current = stage || duplicates || 'all'

//     await fetchInitialData(stage, duplicates)

//     setTimeout(() => {
//       fetchAllRemainingData()
//     }, 1500)
//   }

//   // 🔁 دالة لاستكمال التحميل
//   const resumeLoading = () => {
//     if (!isFetchingRef.current) {
//       console.log("▶️ استكمال التحميل...")
//       fetchAllRemainingData()
//     }
//   }

//   // 🔁 getpages placeholder
//   const getpages = async (page) => {
//     // مش هنستخدم الـ pagination العادي
//   }

//   // 🟢 تجهيز allleads من usersarray
//   const allleads = usersarray.map(item => ({
//     _id: item._id,
//     name: item.name,
//     email: item.email,
//     phone: item.phone,
//     project: item.project?.name || "",
//     sales: item?.sales?.name || null,
//     notes: item.notes,
//     Date: item.date,
//     assign: item.assign,
//     stage: item.stage?.name || "",
//     chanel: item.chanel?.name || "",
//     communicationway: item.communicationway?.name || null,
//     leedtype: item.leedtype,
//     budget: item.budget,
//     stagedateupdated: item.stagedateupdated,
//     createdAt: item.createdAt,
//     updatedAt: item.updatedAt,
//     developer: item.project?.developer || null
//   }))

//   console.log("📋 الحالة النهائية:", {
//     loading,
//     usersarrayLength: usersarray.length,
//     currentStage: currentStageRef.current
//   })

//   return [usersarray, allleads, loading, pagecount, getpages, fetchData, resumeLoading]
// }

import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Getalldatasearch,
  Getallleadsdublicatedinadmindashboard,
} from '../Redux/Actions/UsersAction';
import { useLocation } from 'react-router-dom';
import { io } from 'socket.io-client';
import { db_url } from '../Api/BaseUrl';

export const AllLeadHook = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // 🟡 users from redux
  const users = useSelector((state) => state.Allusers.Get_users);

  const [userlogin, setuserlogin] = useState('');
  const [loading, setloading] = useState(true);
  const [socket, setSocket] = useState(null);

  // 🟢 local state only
  const [usersarray, setUsersArray] = useState([]);

  // استخدام useRef للمتابعة
  const isFetchingRef = useRef(false);
  const currentStageRef = useRef('');
  const pendingRequestRef = useRef(null);
  const pagecount = 1;
  const initialLoadDoneRef = useRef(false);

  // ⬅️ تحميل المستخدم من localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setuserlogin(JSON.parse(storedUser));
    }
  }, []);

  // ⬅️ دالة التحميل الأساسية مع debounce
  const fetchInitialData = async (stage, duplicates) => {
    if (isFetchingRef.current) {
      console.log('⏳ طلب معلق - يوجد طلب قيد التنفيذ');
      return;
    }

    isFetchingRef.current = true;
    setloading(true);
    initialLoadDoneRef.current = false;

    // 🔥 نعمل reset للبيانات قبل ما نبدأ
    setUsersArray([]);
    currentStageRef.current = stage || duplicates || 'all';

    console.log('🚀 بدء تحميل جديد - Stage:', currentStageRef.current);

    try {
      if (duplicates === 'true') {
        await dispatch(Getallleadsdublicatedinadmindashboard(5000));
      } else {
        let query = `leadisactive=true&limit=400`;
        if (stage) query += `&stage=${encodeURIComponent(stage)}`;
        await dispatch(Getalldatasearch(query));
      }
    } catch (error) {
      console.error('❌ خطأ في التحميل الأولي:', error);
    } finally {
      setloading(false);
      isFetchingRef.current = false;
      initialLoadDoneRef.current = true;

      // تنظيف أي طلب معلق
      pendingRequestRef.current = null;
    }
  };

  // ⬅️ جلب البيانات المتبقية - نسخة معدلة
  const fetchAllRemainingData = async () => {
    if (isFetchingRef.current) {
      console.log('⏳ جاري بالفعل جلب البيانات المتبقية');
      return;
    }

    isFetchingRef.current = true;

    const searchParams = new URLSearchParams(location.search);
    const stage = searchParams.get('stage');
    const duplicates = searchParams.get('duplicates');

    try {
      console.log('🔄 بدء جلب البيانات المتبقية...');

      let result;
      if (duplicates === 'true') {
        // ⭐ هنا بنطلب كل البيانات من غير pagination
        result = await dispatch(Getallleadsdublicatedinadmindashboard(5000));
      } else {
        // ⭐ هنا بنطلب كل البيانات من غير pagination
        let query = `leadisactive=true&limit=5000`;
        if (stage) query += `&stage=${encodeURIComponent(stage)}`;
        result = await dispatch(Getalldatasearch(query));
      }

      const allData = result?.payload?.data || result?.data;

      console.log('📦 كل البيانات التي تم جلبها:', allData?.length || 0);

      if (Array.isArray(allData) && allData.length > 0) {
        setUsersArray((prev) => {
          const currentStage = stage || duplicates || 'all';
          if (currentStageRef.current !== currentStage) {
            console.log('⚠️ تخطي دمج البيانات - الـ stage تغير');
            return prev;
          }

          // ⭐ علشان نتأكد إننا بنسخ كل البيانات الجديدة
          console.log(`🔄 دمج البيانات: ${prev.length} → ${allData.length}`);

          // نرجع كل البيانات الجديدة علشان نتأكد إن كل حاجة اتحملت
          return [...allData];
        });
      } else {
        console.log('ℹ️ مفيش بيانات إضافية');
      }
    } catch (error) {
      console.error('❌ خطأ في جلب البيانات المتبقية:', error);
    } finally {
      isFetchingRef.current = false;
    }
  };

  // ⬅️ Effect رئيسي - مدبوث علشان منع الطلبات المتكررة
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const stage = searchParams.get('stage');
    const duplicates = searchParams.get('duplicates');
    const newStage = stage || duplicates || 'all';

    console.log('🎯 تحقق من تغيير الـ Stage:', {
      oldStage: currentStageRef.current,
      newStage: newStage,
    });

    // إذا الـ stage اختلف، نلغي أي طلب معلق ونبدأ جديد
    if (currentStageRef.current !== newStage) {
      console.log('🔄 تغيير في الـ stage - إلغاء الطلبات المعلقة');

      // إلغاء أي طلب معلق
      if (pendingRequestRef.current) {
        clearTimeout(pendingRequestRef.current);
        pendingRequestRef.current = null;
      }

      // تأخير بسيط علشان نتأكد إن الـ URL استقر
      pendingRequestRef.current = setTimeout(() => {
        fetchInitialData(stage, duplicates);

        // ⭐ التحميل الخلفي بعد نجاح التحميل الأولي مباشرة
        const remainingDataTimeout = setTimeout(() => {
          if (currentStageRef.current === newStage) {
            console.log('🕒 بدء التحميل الخلفي...');
            fetchAllRemainingData();
          }
        }, 1000);

        // تنظيف الـ timeout
        return () => clearTimeout(remainingDataTimeout);
      }, 300);
    }

    return () => {
      if (pendingRequestRef.current) {
        clearTimeout(pendingRequestRef.current);
      }
    };
  }, [location.search]);

  // ⬅️ Effect لتحديث البيانات من Redux
  useEffect(() => {
    console.log('📊 تحديث من Redux:', users?.data?.length || 0);

    if (Array.isArray(users?.data)) {
      setUsersArray((prev) => {
        const searchParams = new URLSearchParams(location.search);
        const stage = searchParams.get('stage');
        const duplicates = searchParams.get('duplicates');
        const currentStage = stage || duplicates || 'all';

        if (currentStageRef.current !== currentStage) {
          console.log('⚠️ تخطي تحديث Redux - الـ stage تغير');
          return prev;
        }

        // ⭐ علشان نتأكد إننا بنسخ كل البيانات
        console.log(`🔄 تحديث من Redux: ${prev.length} → ${users.data.length}`);
        return [...users.data];
      });
    }
  }, [users]);

  // ⬅️ Effect جديد: علشان نتأكد إن التحميل الخلفي بيحصل
  useEffect(() => {
    if (!loading && initialLoadDoneRef.current && usersarray.length === 400) {
      console.log('🔍 التحميل الأولي خلص وعدد الـ leads 400, بنجيب الباقي...');

      const timeout = setTimeout(() => {
        if (!isFetchingRef.current) {
          console.log('🚀 تشغيل التحميل الخلفي الآلي...');
          fetchAllRemainingData();
        }
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [loading, usersarray.length]);

  // ⬅️ استماع لـ socket
  useEffect(() => {
    const newSocket = io(db_url);
    setSocket(newSocket);

    newSocket.on('connect', () => {
      console.log('📡 Socket connected');
    });

    newSocket.on('newLead', (newLeadData) => {
      console.log('🆕 New lead via socket');
      setUsersArray((prev) => {
        const isExist = prev.some((item) => item._id === newLeadData._id);
        if (isExist) return prev;
        return [newLeadData, ...prev];
      });
    });

    newSocket.on('newNotification', (updatedLead) => {
      console.log('🔄 Lead updated via socket');
      setUsersArray((prev) =>
        prev.map((item) => (item._id === updatedLead._id ? updatedLead : item)),
      );
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  // 🔁 دالة التحديث اليدوي
  const fetchData = async () => {
    console.log('🔄 تحديث يدوي شامل');

    const searchParams = new URLSearchParams(location.search);
    const stage = searchParams.get('stage');
    const duplicates = searchParams.get('duplicates');

    // reset كامل
    setUsersArray([]);
    isFetchingRef.current = false;
    initialLoadDoneRef.current = false;
    currentStageRef.current = stage || duplicates || 'all';

    await fetchInitialData(stage, duplicates);

    // نجيب كل البيانات بعد التحميل الأولي
    setTimeout(() => {
      fetchAllRemainingData();
    }, 1000);
  };

  // 🔁 دالة لاستكمال التحميل
  const resumeLoading = () => {
    if (!isFetchingRef.current) {
      console.log('▶️ استكمال التحميل...');
      fetchAllRemainingData();
    }
  };

  // 🔁 getpages placeholder
  const getpages = async (page) => {
    // مش هنستخدم الـ pagination العادي
  };

  // 🟢 تجهيز allleads من usersarray
  const allleads = usersarray.map((item) => ({
    _id: item._id,
    name: item.name,
    email: item.email,
    phone: item.phone,
    project: item.project?.name || '',
    sales: item?.sales?.name || null,
    notes: item.notes,
    Date: item.date,
    assign: item.assign,
    stage: item.stage?.name || '',
    chanel: item.chanel?.name || '',
    communicationway: item.communicationway?.name || null,
    leedtype: item.leedtype,
    budget: item.budget,
    stagedateupdated: item.stagedateupdated,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    developer: item.project?.developer || null,
  }));

  console.log('📋 الحالة النهائية:', {
    loading,
    usersarrayLength: usersarray.length,
    currentStage: currentStageRef.current,
    initialLoadDone: initialLoadDoneRef.current,
  });

  return [usersarray, allleads, loading, pagecount, getpages, fetchData, resumeLoading];
};

// اخر واحده كويسه
// =========================================================
